import { createAction } from '@reduxjs/toolkit';
import { IBroadcastMessagesState } from '@store/broadcast-messages/types';

export class GetUsersCountSuccess {
  static get action() {
    return createAction<number>('broadcastMessages/GET_USERS_COUNT_SUCCESS');
  }

  static get reducer() {
    return (
      draft: IBroadcastMessagesState,
      { payload }: ReturnType<typeof GetUsersCountSuccess.action>,
    ) => {
      draft.usersCount = payload;
      draft.requests.getUserCountPending = false;

      return draft;
    };
  }
}
